import { createIcon } from '@chakra-ui/icons';

export const AtSign = createIcon({
  displayName: 'AtSign',
  viewBox: '0 0 15 14',
  path: [
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1963_18687)">
        <path
          d="M13.1081 2.57956C11.0982 -0.160061 6.74774 -0.827686 3.79374 1.15594C0.883486 3.10894 -0.108764 6.96681 1.48199 10.1291C2.70086 12.5511 5.19549 13.9992 7.80561 13.9983C8.55549 13.9983 9.31674 13.8784 10.057 13.6282C10.5146 13.4733 10.7605 12.9763 10.6056 12.5187C10.4516 12.0611 9.95636 11.8143 9.49611 11.9701C6.99624 12.8162 4.22424 11.6848 3.04561 9.34244C1.86874 7.00531 2.62649 4.04694 4.76936 2.60844C7.14149 1.01594 10.3851 1.82444 11.6967 3.61381C12.6129 4.86331 12.7835 6.76906 12.0852 7.95294C11.6626 8.67394 11.0974 8.82356 10.8235 8.74744C10.687 8.71069 10.6765 8.64944 10.6765 8.56631V4.31294C10.6765 3.82994 10.2854 3.43794 9.80149 3.43794C9.44974 3.43794 9.15049 3.64881 9.01136 3.94806C8.53361 3.66019 7.98849 3.48256 7.40049 3.48256C5.59974 3.48256 4.13499 5.02256 4.13499 6.91519C4.13499 8.80781 5.60061 10.3478 7.40049 10.3478C8.10574 10.3478 8.75499 10.1063 9.28874 9.70556C9.53986 10.0521 9.90824 10.3128 10.3632 10.4371C11.345 10.7039 12.7257 10.3146 13.5929 8.84194C14.6359 7.07181 14.4285 4.37944 13.1081 2.57956ZM7.40049 8.59781C6.56486 8.59781 5.88499 7.84269 5.88499 6.91519C5.88499 5.98769 6.56486 5.23256 7.40049 5.23256C8.23611 5.23256 8.91599 5.98769 8.91599 6.91519C8.91599 7.84269 8.23611 8.59781 7.40049 8.59781Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1963_18687">
          <rect width="14" height="14" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
